// Shared game state — multi-kingdom shape since Phase 3.
//
// `state` is the persisted root: { activeKingdom, kingdoms: { WEI, SHU, WU } }.
// Most subsystems shouldn't touch the root — they call `active()` to get the
// currently-selected kingdom's state slice and mutate that. Switching kingdoms
// is a single field change handled by kingdomManager.

import { load, save } from './save.js'

export const state = load()

export function active() {
  return state.kingdoms[state.activeKingdom]
}

export function activeId() {
  return state.activeKingdom
}

export function getProfile() {
  return state.profile
}

export function getKingdom(id) {
  return state.kingdoms[id]
}

export function setActiveKingdom(id) {
  state.activeKingdom = id
  persist()
}

// Every change to the game goes through persist(). The cloud sync hooks in here so it sees EVERY change (not just a list of
// events), and counts changes so it knows whether anything happened while a save was in flight.
let persistHook = null
let frozen = false
export function setPersistHook(fn) { persistHook = fn }
// After this, nothing is written to localStorage or synced any more. Used when signing out (the game keeps running for a
// moment before the page reloads and must not re-save the previous player's game) and when this window is blocked because the
// game is active somewhere else (it must not overwrite the other window's saved game).
export function freezePersistence() { frozen = true }
export function persist() {
  if (frozen) return
  save(state)
  persistHook?.()
}
